import type { ExcalidrawImperativeAPI } from '@excalidraw/excalidraw/types/types'

const STORAGE_KEY = 'fitutogether-canvas-close-scene'

export interface StoredCanvasScene {
  elements: ReturnType<ExcalidrawImperativeAPI['getSceneElements']>
  files: ReturnType<ExcalidrawImperativeAPI['getFiles']>
  viewBackgroundColor: string
}

export function writeCanvasSceneForClose(scene: StoredCanvasScene): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(scene))
  } catch {
    /* quota — fail silently */
  }
}

export function readCanvasSceneForClose(): StoredCanvasScene | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    return JSON.parse(raw) as StoredCanvasScene
  } catch {
    return null
  }
}

export function clearCanvasSceneForClose(): void {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch {
    /* ignore */
  }
}
